export * from './oidc.js';
export * from './react.js';
export { principalFromAccessToken, safeReturnTo } from './store.js';
export type * from './types.js';

/**
 * The Keycloak account console page where the user sets or changes the password (D-47): «تعیین یا
 * تغییر رمز عبور» on every app's account page. `authority` is the realm issuer (`…/realms/saay`).
 * The account console logs in with the same SAAY page (SMS code or mobile + password) and starts
 * Keycloak's UPDATE_PASSWORD action; no password ever passes through the app.
 */
export function accountPasswordUrl(authority: string): string {
  return `${authority.replace(/\/+$/, '')}/account/account-security/signing-in`;
}

/** The Keycloak public clients of the web apps (T-01, AC §6.1) and their local origins. */
export const WEB_CLIENTS = {
  'admin-web': { clientId: 'saay-admin-web', origin: 'http://127.0.0.1:3001' },
  'buyer-web': { clientId: 'saay-buyer-web', origin: 'http://127.0.0.1:3003' },
  'merchant-web': { clientId: 'saay-merchant-web', origin: 'http://127.0.0.1:3002' },
} as const;
